import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import IconButton from 'material-ui/IconButton';
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'UPageComponent';

var styles = AppSettings.styles;

class UPage extends React.Component {
    constructor(props, context) {
        super(props);
        this.openPage = this.openPage.bind(this);
    }
    
    openPage(){
        var body = this.props.children;
        this.context.handleSetPage(this.props.PageTitle, body,true);
    }

    render(){
            return(<>
                    <IconButton iconStyle={styles.miniIcon} tooltipPosition="top-left" tooltip={this.props.Tooltip} iconClassName="fa fa-cog" 
                    onClick={this.openPage}
                    style={styles.cardMiniIcon} className="card-mini-icon"/> 
                    </>
            )
    }
}

UPage.displayName = componentName;

// PropTypes validation
UPage.propTypes = {
    classNameButton: PropTypes.string,
    typeButton: PropTypes.string
};

// default props
UPage.defaultProps = {
    classNameButton: "",
    typeButton: "button"
};

UPage.contextTypes = {
    handleSetPage: PropTypes.func,
    userboxOpened: PropTypes.bool,
    handleTab: PropTypes.func
}
export default  UPage;